import { useLocalStorage } from "~/modules/app/hooks/useLocalStorage";

import { MapCenterAddress, MapCenterMode } from "./types";

type MapCenterPreference = {
    mode: MapCenterMode;
    address: MapCenterAddress | null;
};

export function useMapCenterPreference() {
    const [preference, setPreference] = useLocalStorage<MapCenterPreference>({
        key: "mapCenterPreference",
        initialValue: { mode: "bounds", address: null },
    });

    return {
        mode: preference.mode,
        address: preference.address,
        selectBounds: () => setPreference({ ...preference, mode: "bounds" }),
        selectAddress: (address: MapCenterAddress) => setPreference({ mode: "address", address }),
    };
}
